import { Box, Typography } from '@mui/material';
import { ReactComponent as TransactionTypesIcon } from '../../../../assets/icons/transaction-types-icon.svg';

const Content = [
  {
    title: 'Principal Repayment ',
    description: `
      • Principal Repayment = Collection (aka Revenue share) - Interest Component (basis the pricing methodology) = Principal
      • In the case of simple interest, every month’s collection includes principal plus interest
      • In the case of dynamic return cap, interest is collected after the entire principal is repaid
      • This split between principal and interest is to be computed in BigQuery and added to the revenue ledger.
      `,
  },
  {
    title: 'Average Exposure for a given month',
    description: `
      Since the settlement date for financing falls in the middle of a month and the exposure is different on either side of that settlement date, 
      we calculate average of the exposure taking into account days in the month before and after the settlement date.\n
      For example, if the settlement date is 25th,
      Average Exposure = (Exposure from 1st to 25th * 25 + Exposure from 26th till End of the month * #days till end of the month) / #days in the month
      `,
  },
  {
    title: 'Cost of Capital',
    description: `
      GC’s Target IRR is fixed at 16%.\n
      Cost of Capital = GC’s Average Exposure for a given month * 16% / 12`,
  },
  {
    title: 'Gross Margin',
    description: `
      Gross Margin = Gross Accounting Revenue - Cost of Capital`,
  },
];

const AccountingRevenueContent = () => {
  return (
    <>
      {Content.map((item, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '1rem',
            borderRadius: '0.75rem',
            backgroundColor: '#FFFFFF',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: '0.5rem',
              alignItems: 'center',
              marginBottom: '0.5rem',
            }}
          >
            <TransactionTypesIcon />
            <Typography
              sx={{
                fontFamily: 'Manrope, sans-serif',
                fontWeight: 700,
                fontSize: '1rem',
              }}
            >
              {item.title}
            </Typography>
          </Box>
          {item.description
            .trim()
            .split('\n')
            .map((line, idx) =>
              line.trim() === '' ? (
                <Box key={idx} sx={{ height: '0.75rem' }} />
              ) : (
                <Typography
                  key={idx}
                  sx={{
                    color: '#6C6C6C',
                    fontFamily: 'Manrope, sans-serif',
                    fontWeight: 500,
                    fontSize: '0.875rem',
                    marginBottom: '0.25rem',
                    marginLeft: '0.5rem',
                  }}
                >
                  {line.trim()}
                </Typography>
              ),
            )}
        </Box>
      ))}
    </>
  );
};

export default AccountingRevenueContent;
